import { render, staticRenderFns } from "./manage-promos.vue?vue&type=template&id=131b2e34&"
import script from "./manage-promos.vue?vue&type=script&lang=js&"
export * from "./manage-promos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports